import React, { PropsWithChildren } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Box, BoxProps } from "arkh";

const ROW_HEIGHT = 50;
export const FIRST_ROW_HEIGHT = 50;
export const COLUMN_WIDTH = 60;
export const FIRST_COLUMN_WIDTH = 120;

export function RowItem({
  children,
  first,
  style,
  height,
  ...boxProps
}: PropsWithChildren<
  {
    style?: StyleProp<ViewStyle>;
    first?: boolean;
    height?: number;
  } & BoxProps
>) {
  return (
    <Box
      space="xsmall"
      borderColor="border-primary"
      style={{
        height:
          height !== undefined ? height : first ? FIRST_ROW_HEIGHT : ROW_HEIGHT,
      }}
    >
      <Box style={[{ flex: 1 }, style]} {...boxProps}>
        {children}
      </Box>
    </Box>
  );
}
export function ColumnItem({
  first,
  children,
  style,
  ...boxProps
}: PropsWithChildren<
  { first?: boolean } & BoxProps & { style?: StyleProp<ViewStyle> }
>) {
  return (
    <Box
      style={[
        {
          width: first ? FIRST_COLUMN_WIDTH : COLUMN_WIDTH,
        },
        style,
      ]}
      borderColor="border-primary"
      {...boxProps}
    >
      {children}
    </Box>
  );
}
